import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { Page } from "../types";
import { isTemplateInterfacePageId } from "../utils";

export const fetchInterfacePageAtomFamily_SUSPENDS = atomFamily(
  ({
    interfacePageId,
    interfaceProjectId,
  }: {
    interfacePageId: string | undefined;
    interfaceProjectId: string | undefined;
  }) => {
    const baseAtom = atom(async () => {
      if (!interfacePageId || !interfaceProjectId) {
        return;
      }

      const isTemplateInterfacePage =
        isTemplateInterfacePageId(interfacePageId);

      if (isTemplateInterfacePage) {
        // Because we don't want to fetch with template asset id and get a 404 Not Found error
        return;
      }

      try {
        const res = await fetch(
          `/api/canvasui/interfaces/${interfaceProjectId}/pages/${interfacePageId}`,
        );

        if (res.ok) {
          const {
            result: { data },
          } = await res.json();

          return {
            blocks: data.content.blocks,
            name: data.name,
            id: data.id,
            slug: data.slug,
          } as Page;
        } else {
          return null;
        }
      } catch {
        return null;
      }
    });

    baseAtom.debugLabel = `fetchInterfacePageAtomFamily_SUSPENDS({interfacePageId: ${interfacePageId}, interfaceProjectId: ${interfaceProjectId}})`;
    return baseAtom;
  },
  (a, b) =>
    a.interfacePageId === b.interfacePageId &&
    a.interfaceProjectId === b.interfaceProjectId,
);
